import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import LoadingScreen from "./commons/LoadingScreen";

const AuthRoutes = () => {
  const { isAuth, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};

export default AuthRoutes;
